import { OrderDto } from '../api-types';

export function getOrdersPrice(orders: OrderDto[]): string {
    return orders.reduce((a, b) => a + b.price || 0, 0).toFixed(2);
}
